<template>
  <router-view/>
</template>

<script>
export default {
  name: 'App',
  created () {
    console.log('URL Redirect v.' + this.$environment.getVersion())
  }
}
</script>

<style scoped lang="less">
</style>
